export namespace Auth {
  export function isInternalAccount(email?: string | null) {
    if (!email) return false;
    return email.endsWith('@fuuze.app') || email.endsWith('@test.mail');
  }
}
